import { ExtendedLineItem } from 'shared/types/cart/LineItem';
import {
  CART_CUSTOM_LINE_ITEM_ID_QUERY_PARAM,
  CART_ITEM_FINISH_QUERY_PARAM,
  CART_ITEM_QUANTITY_QUERY_PARAM,
  CART_LINE_ITEM_ID_QUERY_PARAM,
  SHEEN_QUERY_PARAM,
  WIREBRUSH_QUERY_PARAM,
} from 'helpers/constants/query-params';

export interface CartItemLinks {
  /** PDP with the line's options preselected and the line id, so Add to Cart becomes Update cart. */
  editUrl?: string;
  /** PDP with the line's options preselected but no line id, so Add to Cart adds a sibling line. */
  addVariantUrl?: string;
}

// The Edit / Add Variant destinations for a cart line, shared by the cart page rows and the header
// cart drawer so both open the PDP with the same preselected finish, sheen, wirebrush and quantity.
export const getCartItemLinks = (item: ExtendedLineItem): CartItemLinks => {
  // Builder (designId) and RoleModel (isDPQLineItem) lines are configured externally, so they have
  // no product page to edit and get no links at all.
  const isExternallyConfigured =
    item.custom?.fields?.isDPQLineItem === true || !!item.custom?.fields?.designId;
  const productUrl = item._url;

  if (!productUrl || isExternallyConfigured) return {};

  const params = new URLSearchParams();
  params.set(CART_ITEM_QUANTITY_QUERY_PARAM, String(item.count ?? 1));
  if (item.config?.finish) params.set(CART_ITEM_FINISH_QUERY_PARAM, String(item.config.finish));
  if (item.config?.sheen) params.set(SHEEN_QUERY_PARAM, String(item.config.sheen));
  if (item.config?.wirebrush !== undefined) params.set(WIREBRUSH_QUERY_PARAM, String(item.config.wirebrush));

  const addVariantUrl = `${productUrl}?${params.toString()}`;

  if (!item.lineItemId) return { addVariantUrl };

  params.set(CART_LINE_ITEM_ID_QUERY_PARAM, item.lineItemId);
  if (item.customLineItemId) params.set(CART_CUSTOM_LINE_ITEM_ID_QUERY_PARAM, item.customLineItemId);

  return { editUrl: `${productUrl}?${params.toString()}`, addVariantUrl };
};
